module.exports = __webpack_public_path__ + "static/media/esg_schema_sk.76a68d0b.svg";